import { mainTextGray, pageDescription } from '../../../theme';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    zIndex: 999,
    '& p': {
      marginTop: 20,
    },
  },
  opacity: {
    backgroundColor: pageDescription,
    color: mainTextGray,
    opacity: 0.8,
  },
  loader: {
    zIndex: 1000,
  }
});

export default styles;
